module.exports = __webpack_public_path__ + "img/car_7_audi.c99f4438.jpg";